import {
  createContext,
  useContext,
} from 'react'

// Dialogs are modal unless something above them says otherwise, so the default
// covers the embed path and only the dashboard's preview needs a provider.
//
const IsModelessContext = createContext(false)


export default IsModelessContext

export function useIsModeless() {
  return useContext(IsModelessContext)
}
